<template>
  <div class="d-inline-block float-right"
    v-if="mustShow">
    <b-button
      v-if="!permissions || permissions.readMessages || permissions.viewFiles"
      variant="outline-primary"
      class="bg-white"
      style="position: relative;"
      @click.prevent="toggleAside()">
      <i class="fa fa-fw fa-bell"></i>
      <b-badge v-if="notifications" pill variant="danger" style="position: absolute; top: 2em;">
        {{ notifications }}
      </b-badge>
    </b-button>
    <AppAside fixed style="top: 55px;">
      <DefaultAside
        :context="context"
        :context-id="contextId"
        :workgroup-id="workgroupId"
        :permissions="permissions"
        @close="toggleAside()"
        @message="onNotification"
        @file="onNotification" />
    </AppAside>
  </div>
</template>
<script>
import { Aside as AppAside } from '@coreui/vue';
import DefaultAside from 'app/ui/DefaultAside';
import AsideTogglerMixin from 'vue-core/mixins/AsideTogglerMixin';

export default {
  mixins: [AsideTogglerMixin],

  components: {
    AppAside,
    DefaultAside
  },

  props: {
    context: {
      type: String,
      required: true
    },

    contextId: {
      type: [String, Number],
      required: true
    },

    workgroupId: {
      type: Number,
      required: true,
    },

    open: {
      type: Boolean,
      default: false
    },

    permissions: {
      type: Object,
      default: undefined
    }
  },

  data() {
    return {
      notifications: 0
    };
  },

  computed: {
    mustShow() {
      return !this.permissions
          || this.permissions.readMessages
          || this.permissions.viewFiles;
    }
  },

  mounted() {
    if (this.open && this.mustShow) {
      this.toggleAside(true);
    }
  },

  methods: {
    onNotification(msg) {
      if (!this.isAsideVisible()) {
        this.notifications++;
      }
    },

    toggled() {
      if (this.isAsideVisible()) {
        this.notifications = 0;
      }
    },

    isAsideVisible() {
      return document
          .querySelector('body')
          .classList
          .contains('aside-menu-show');
    }
  }
}
</script>
